import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../../axios';
import { moduleName } from '../../moduleInfo';
import {
  getAllLeadDetailsRoute,
  getAssingedToListRoute,
  getSingleLeadDetailsRoute,
  getViewFormRoute,
  updateAdmissionStatusRoute,
} from '../../utils/apiRoutes';

// export const setAdmissionFeeAsync = createAsyncThunk(
//   `${moduleName}/setAdmissionFee`,
//   async (payload) => {
//     const { admissionFormFees, schoolId } = payload;
//     const response = await axios({
//       method: 'PUT',
//       url: createAdmissionFormFeeRoute(schoolId),
//       data: { admissionFormFees },
//     });
//     const data = response.data;
//     return data;
//   }
// );

export const getAllLeadDetailsAsync = createAsyncThunk(
  `${moduleName}/getAllLeadDetails`,
  async (payload) => {
    // const { schoolIds } = payload;
    // console.log('payloads archive', { ...payload });
    const response = await axios({
      method: 'GET',
      url: getAllLeadDetailsRoute(),
      params: {
        ...payload,
        limit: 6,
        // admissionStatus: 'pending',
        // schoolIds: schoolIds,
        // limit: 10,
      },
    });
    // console.log('leadDetail pending', response.data);
    const data = response.data;
    return data;
  }
);

export const getAllArchiveLeadDetailsAsync = createAsyncThunk(
  `${moduleName}/getAllArchiveLeadDetailsAsync`,
  async (payload) => {
    // const { schoolIds } = payload;
    // console.log('payloads archive', { ...payload });
    const response = await axios({
      method: 'GET',
      url: getAllLeadDetailsRoute(),
      params: {
        ...payload,
        admissionStatus: 'archive',
        limit: 6,
        // schoolIds: schoolIds,
        // limit: 10,
      },
    });
    // console.log('leadDetail archive', response.data);
    const data = response.data;
    return data;
  }
);

export const getAssignedToListAsync = createAsyncThunk(
  `${moduleName}/getAssignedToList`,
  async (payload) => {
    const response = await axios({
      method: 'GET',
      url: getAssingedToListRoute(),
      params: {
        ...payload,
        // schoolIds: schoolIds,
        // limit: 10,
      },
    });
    // console.log('response', response.data);
    const data = response.data;
    return data;
  }
);

export const getSingleLeadDetails = createAsyncThunk(
  `${moduleName}/getSingleLeadDetails`,
  async (payload) => {
    // console.log('payload', payload);
    const response = await axios({
      method: 'GET',
      url: getSingleLeadDetailsRoute(),
      params: {
        ...payload,
      },
    });
    // console.log('response', response.data);
    const data = response.data;
    return data;
  }
);

export const updateAdmissionStatusAsync = createAsyncThunk(
  `${moduleName}/updateAdmissionStatus`,
  async (payload) => {
    // console.log('payload update status', { ...payload });
    const response = await axios({
      method: 'PUT',
      url: updateAdmissionStatusRoute(),
      data: { ...payload },
    });
    const data = response.data;
    // console.log('response admission status', data);
    return data;
  }
);

export const getViewFormAsync = createAsyncThunk(
  `${moduleName}/getViewForm`,
  async (payload) => {
    // console.log('payload', payload);
    const response = await axios({
      method: 'GET',
      url: getViewFormRoute(),
      params: {
        ...payload,
      },
    });
    // console.log('response', response.data);
    const data = response.data;
    return data;
  }
);

const confirmAdmissionSlice = createSlice({
  name: `${moduleName}/confirmAdmission`,
  initialState: {
    loading: false,
    assignedToList: [],
    pendingTableCount: 1,
    pendingTableData: [],
    archiveTableData: [],
    archiveTableCount: 1,
    leadDetails: {},
    leadInfo: {},
    admissionStatus: '',
    viewForm: [],
    error: '',
  },
  reducers: {
    leadDetailsData: (state, action) => {
      state.leadDetails = action.payload;
    },
  },
  extraReducers: {
    [getAllLeadDetailsAsync.pending]: (state) => {
      state.loading = true;
    },
    [getAllLeadDetailsAsync.fulfilled]: (state, action) => {
      //   console.log('pending data', action.payload.data);
      state.loading = false;
      state.pendingTableData = action.payload.data;
      state.pendingTableCount = action.payload.count;
    },
    [getAllLeadDetailsAsync.rejected]: (state) => {
      state.loading = false;
    },
    [getAllArchiveLeadDetailsAsync.pending]: (state) => {
      state.loading = true;
    },
    [getAllArchiveLeadDetailsAsync.fulfilled]: (state, action) => {
      //   console.log('archive data', action.payload.data);
      state.loading = false;
      state.archiveTableData = action.payload.data;
      state.archiveTableCount = action.payload.count;
    },
    [getAllArchiveLeadDetailsAsync.rejected]: (state) => {
      state.loading = false;
    },
    [getAssignedToListAsync.pending]: (state) => {
      state.loading = true;
    },
    [getAssignedToListAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.assignedToList = action.payload.data;
    },
    [getAssignedToListAsync.rejected]: (state) => {
      state.loading = false;
    },
    [getSingleLeadDetails.pending]: (state) => {
      state.loading = true;
    },
    [getSingleLeadDetails.fulfilled]: (state, action) => {
      state.loading = false;
      //   console.log('single lead detail', action.payload);
      state.leadInfo = action.payload.data;
      //   state.leadInfo = {
      //     lead: {
      //       displayId: 119561,
      //       name: 'amaraboti',
      //       imageUrl: '60e7062e833c50a328d51d4c_image_key_maxresdefault.jpg',
      //       status: 'new',
      //       createdDate: '2021-09-11T09:58:11.562Z',
      //       hotLead: true,
      //     },
      //     admission: {
      //       formId: '256345',
      //       class: '10',
      //       schoolName: 'flower school',
      //       dateOfSubmission: '2021-09-18T00:00:00.000Z',
      //     },
      //   };
    },
    [getSingleLeadDetails.rejected]: (state) => {
      state.loading = false;
    },
    [updateAdmissionStatusAsync.pending]: (state) => {
      state.loading = true;
    },
    [updateAdmissionStatusAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.admissionStatus = action.payload;
    },
    [updateAdmissionStatusAsync.rejected]: (state) => {
      state.loading = false;
    },
    [getViewFormAsync.pending]: (state) => {
      state.loading = true;
    },
    [getViewFormAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.viewForm = action.payload.data;
    },
    [getViewFormAsync.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const { leadDetailsData } = confirmAdmissionSlice.actions;

export default confirmAdmissionSlice.reducer;
